import { joinPath } from '@eventbrite/path-utils';
import {
    BASE_URL,
    CHECKOUT_PATH,
    DELIVERY_METHODS_PATH,
    RESERVED_TICKETS_CONFIRMATION_PATH,
} from '../../../constants';
import { shouldShowDeliveryMethodPage } from './shouldShowDeliveryMethodPage';

export const getPathAfterTicketSelection = ({
    shouldShowReservedTicketsFlow,
    attendees,
}) => {
    let path = CHECKOUT_PATH;

    if (shouldShowReservedTicketsFlow) {
        path = RESERVED_TICKETS_CONFIRMATION_PATH;
    } else if (shouldShowDeliveryMethodPage(attendees)) {
        path = DELIVERY_METHODS_PATH;
    }

    return joinPath(BASE_URL, path);
};
